import React from 'react';
import { cn } from '@/lib/utils';
import { AnchorIcon } from '@/components/ui/anchor-icon';
import { useChat } from '@/context/ChatContext';

export function AskAnchorButton({ onClick, className, size = 'md', active }) {
  const chat = useChat();

  const sizeClasses = {
    sm: 'h-8 px-3 text-xs',
    md: 'h-10 px-4 text-sm',
  };

  const isActive = active !== undefined ? active : chat.panelOpen;

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    } else {
      // Default: toggle the chat panel
      if (chat.panelOpen) {
        chat.closePanel();
      } else {
        chat.startNewChat('');
      }
    }
  };

  return (
    <button
      onClick={handleClick}
      className={cn(
        'btn-ask-anchor inline-flex items-center justify-center gap-2 rounded-full font-medium',
        'transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 focus-visible:ring-offset-2',
        'active:scale-[0.98]',
        sizeClasses[size],
        isActive && 'ring-2 ring-primary/30',
        className
      )}
    >
      <AnchorIcon className="h-4 w-4" />
      <span>Ask Anchor</span>
    </button>
  );
}
